import BaseModel from "@api/models/BaseModel";
import UIBaseModel from "@models/UIBaseModel";
import FoodPrice from "./FoodPrice";
import SideDish from "./SideDish";

export default class Food implements BaseModel, UIBaseModel {
    isSelected: boolean;
    id: string;
    dateCreated: Date;
    dateEdited: Date;
    description: string;
    foodCategoryId: string;
    foodPrices: FoodPrice[];
    sideDishes: SideDish[];
    freeSideDishes: number;
    imageUrl: string;
    isActive: boolean;
    name: string;
    restaurantId: string;
    sideDishesEnabled: boolean;
}